import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import { cloneDeep } from "lodash";
import { Link, useNavigate, useParams } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import { MANAGE_PARENTS_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import addParentSchema from "./addParent.schema";
import { useCreateParentMutation, useGetParentDetailQuery, useUpdateParentMutation } from "store/services/parents";
import { STATUS_OPTIONS } from "config/constants";
import Switch from "react-switch";
import { RequiredFieldAstrick } from "components/Common/Common";

const AddParent = () => {

  const { id: parentId } = useParams();
  const editMode = !!parentId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    city: "",
    status: "archived",
    isLoginAllowed: "archived",
  });

  const [updateParent, { isLoading: updateClientLoading }] = useUpdateParentMutation();
  const [createParent, { isLoading: createClientLoading }] = useCreateParentMutation();
  const { data: parentDetails, isLoading } = parentId ? useGetParentDetailQuery(parentId) : {};

  const handleSubmit = async (payload) => {

    try {

      const values = cloneDeep(payload);
      const result = editMode ? await updateParent({ data: values, parentId }) : await createParent(values);
      if (result?.error) {

        console.error("Error Private Client", result.error);
        return;
      };

      successMessageToast(result?.data?.message);
      navigate(MANAGE_PARENTS_LIST);

    } catch (err) { console.error("Error Private Client", err); }
  };

  const handleChange = (value) => {
    setInitialValues({
      ...initialValues,
      isLoginAllowed: value ? "active" : "archived"
    })
  };

  useEffect(() => {

    if (!parentId) return;

    if (parentDetails) {

      setInitialValues({
        ...initialValues,
        firstname: parentDetails?.firstname || "",
        lastname: parentDetails?.lastname || "",
        phone: parentDetails?.phone || "",
        email: parentDetails?.email || "",
        city: parentDetails?.guardianDetail?.city || "",
        status: parentDetails?.status || "",
        isLoginAllowed: parentDetails?.isLoginAllowed || ""
      });
    };

  }, [parentDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <div className="pageHead pb-3 d-flex align-items-center">
                    <Link
                      className="themeBlue fw-sbold back-to-btn"
                      to={MANAGE_PARENTS_LIST}
                    >
                      <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                      </svg> Back
                    </Link>
                    <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Parent" : "Add New Parent"}</h6>
                  </div>
                </div>
                {/* <div className="right">
                  <div className="content d-flex align-items-center">
                    <h6 className="m-0 fw-bold themeBlue px-2">Activate Account</h6>
                    <Switch
                      uncheckedIcon={""}
                      checkedIcon={""}
                      onHandleColor={"#A3DF00"}
                      offHandleColor={"#A3DF00"}
                      onColor={"#E6E6E6"}
                      offColor={"#E6E6E6"}
                      height={18}
                      width={40}
                      onChange={handleChange}
                      checked={initialValues.isLoginAllowed === "active"}
                      disabled={createClientLoading || updateClientLoading}
                      defaultChecked={true}
                    />
                  </div>
                </div> */}
              </div>

            </Col>
            {
              isLoading ? <LoadingIndicator /> :
                <Col lg="12" className="my-2">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={addParentSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Last Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="lastname"
                                placeholder="e.g Smith"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                First Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="firstname"
                                placeholder="e.g John"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Phone
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="phone"
                                placeholder="e.g +1 23234545"
                                className={`${styles.formControl} form-control`}
                                maxLength={25}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Email
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="email"
                                placeholder="e.g abc@example.com"
                                className={`${styles.formControl} form-control`}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                City
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="city"
                                placeholder="City"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            {/* <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0"
                              >
                                Status
                              </label>
                              <AppSelectField
                                name={"status"}
                                placeholder={"Please Select"}
                                className={`${styles.formControl} form-control`}
                                options={STATUS_OPTIONS}
                              />
                            </Col>                            */}
                          </Row>
                        </div>                       
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button disabled={createClientLoading || updateClientLoading} type="submit" className="d-flex align-items-center justify-content-center commonBtn">
                                {createClientLoading || updateClientLoading ? <LoadingIndicator inline /> : "Save"}

                              </Button>
                              <Button
                                type="button"
                                className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                onClick={() => navigate(MANAGE_PARENTS_LIST)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddParent;
